// extracted by mini-css-extract-plugin
export default {"banner":"DemoBanner_banner__ykoJa","icon":"DemoBanner_icon__vUovL","cta":"DemoBanner_cta__hNL-9"};